// Safe funny messages for transition messages

import type { AccentToStringMap } from '../../types';

export const FUNNY_SAFE: Record<string, AccentToStringMap> = {
  bubbleBath: {
    'en-US': '...and taking a bubble bath',
    'en-GB': '...and having a bubble bath',
    'en-AU': '...and having a bubble bath',
    'en-IN': '...and taking a bubble bath',
    'es-ES': '...y tomando un baño de burbujas',
    'es-US': '...y tomando un baño de burbujas',
  },
  runningMarathon: {
    'en-US': '...and running a marathon',
    'en-GB': '...and running a marathon',
    'en-AU': '...and running a marathon',
    'en-IN': '...and running a marathon',
    'es-ES': '...y corriendo una maratón',
    'es-US': '...y corriendo una maratón',
  },
  savingWorld: {
    'en-US': '...and saving the world',
    'en-GB': '...and saving the world',
    'en-AU': '...and saving the world',
    'en-IN': '...and saving the world',
    'es-ES': '...y salvando el mundo',
    'es-US': '...y salvando el mundo',
  },
  dancingInRain: {
    'en-US': '...and dancing in the rain',
    'en-GB': '...and dancing in the rain',
    'en-AU': '...and dancing in the rain',
    'en-IN': '...and dancing in the rain',
    'es-ES': '...y bailando bajo la lluvia',
    'es-US': '...y bailando bajo la lluvia',
  },
  makingPaperclipChain: {
    'en-US': '...and making a paperclip chain',
    'en-GB': '...and making a paperclip chain',
    'en-AU': '...and making a paperclip chain',
    'en-IN': '...and making a paperclip chain',
    'es-ES': '...y haciendo una cadena de clips',
    'es-US': '...y haciendo una cadena de clips',
  },
  buildingBlanketFort: {
    'en-US': '...and building a blanket fort',
    'en-GB': '...and building a blanket fort',
    'en-AU': '...and building a blanket fort',
    'en-IN': '...and building a blanket fort',
    'es-ES': '...y construyendo un fuerte de mantas',
    'es-US': '...y construyendo un fuerte de cobijas',
  },
  eatingBreakfast: {
    'en-US': '...and eating breakfast',
    'en-GB': '...and eating breakfast',
    'en-AU': '...and eating brekkie',
    'en-IN': '...and eating breakfast',
    'es-ES': '...y desayunando',
    'es-US': '...y desayunando',
  },
  chasingSquirrels: {
    'en-US': '...and chasing squirrels',
    'en-GB': '...and chasing squirrels',
    'en-AU': '...and chasing squirrels',
    'en-IN': '...and chasing squirrels',
    'es-ES': '...y persiguiendo ardillas',
    'es-US': '...y persiguiendo ardillas',
  },
  hopingForMiracle: {
    'en-US': '...and hoping for a miracle',
    'en-GB': '...and hoping for a miracle',
    'en-AU': '...and hoping for a miracle',
    'en-IN': '...and hoping for a miracle',
    'es-ES': '...y esperando un milagro',
    'es-US': '...y esperando un milagro',
  },
  hostingTeaParty: {
    'en-US': '...and hosting a tea party',
    'en-GB': '...and hosting a tea party',
    'en-AU': '...and hosting a tea party',
    'en-IN': '...and hosting a tea party',
    'es-ES': '...y organizando una fiesta de té',
    'es-US': '...y organizando una fiesta de té',
  },
  teachingOldDog: {
    'en-US': '...and teaching an old dog new tricks',
    'en-GB': '...and teaching an old dog new tricks',
    'en-AU': '...and teaching an old dog new tricks',
    'en-IN': '...and teaching an old dog new tricks',
    'es-ES': '...y enseñando trucos nuevos a un perro viejo',
    'es-US': '...y enseñando trucos nuevos a un perro viejo',
  },
  foldingLaundry: {
    'en-US': '...and folding laundry',
    'en-GB': '...and folding laundry',
    'en-AU': '...and folding the washing',
    'en-IN': '...and folding laundry',
    'es-ES': '...y doblando la ropa',
    'es-US': '...y doblando la ropa',
  },
  savingPrincess: {
    'en-US': '...and saving the princess',
    'en-GB': '...and saving the princess',
    'en-AU': '...and saving the princess',
    'en-IN': '...and saving the princess',
    'es-ES': '...y salvando a la princesa',
    'es-US': '...y salvando a la princesa',
  },
  gazingAtStars: {
    'en-US': '...and gazing at the stars',
    'en-GB': '...and gazing at the stars',
    'en-AU': '...and gazing at the stars',
    'en-IN': '...and gazing at the stars',
    'es-ES': '...y contemplando las estrellas',
    'es-US': '...y contemplando las estrellas',
  },
  knittingSweater: {
    'en-US': '...and knitting a sweater',
    'en-GB': '...and knitting a jumper',
    'en-AU': '...and knitting a jumper',
    'en-IN': '...and knitting a sweater',
    'es-ES': '...y tejiendo un suéter',
    'es-US': '...y tejiendo un suéter',
  },
  rehearsingAcceptanceSpeech: {
    'en-US': '...and rehearsing an acceptance speech',
    'en-GB': '...and rehearsing an acceptance speech',
    'en-AU': '...and rehearsing an acceptance speech',
    'en-IN': '...and rehearsing an acceptance speech',
    'es-ES': '...y ensayando un discurso de aceptación',
    'es-US': '...y ensayando un discurso de aceptación',
  },
  sleepingIn: {
    'en-US': '...and sleeping in',
    'en-GB': '...and having a lie-in',
    'en-AU': '...and having a sleep-in',
    'en-IN': '...and sleeping in',
    'es-ES': '...y durmiendo hasta tarde',
    'es-US': '...y durmiendo hasta tarde',
  },
  waitingForTrain: {
    'en-US': '...and waiting for the train',
    'en-GB': '...and waiting for the train',
    'en-AU': '...and waiting for the train',
    'en-IN': '...and waiting for the train',
    'es-ES': '...y esperando el tren',
    'es-US': '...y esperando el tren',
  },
  countingSheep: {
    'en-US': '...and counting sheep',
    'en-GB': '...and counting sheep',
    'en-AU': '...and counting sheep',
    'en-IN': '...and counting sheep',
    'es-ES': '...y contando ovejas',
    'es-US': '...y contando ovejitas',
  },
  startingPillowFight: {
    'en-US': '...and starting a pillow fight',
    'en-GB': '...and starting a pillow fight',
    'en-AU': '...and starting a pillow fight',
    'en-IN': '...and starting a pillow fight',
    'es-ES': '...y empezando una pelea de almohadas',
    'es-US': '...y empezando una pelea de almohadas',
  },
  defyingGravity: {
    'en-US': '...and defying gravity',
    'en-GB': '...and defying gravity',
    'en-AU': '...and defying gravity',
    'en-IN': '...and defying gravity',
    'es-ES': '...y desafiando la gravedad',
    'es-US': '...y desafiando la gravedad',
  },
  doingHomework: {
    'en-US': '...and doing homework',
    'en-GB': '...and doing homework',
    'en-AU': '...and doing homework',
    'en-IN': '...and doing homework',
    'es-ES': '...y haciendo los deberes',
    'es-US': '...y haciendo la tarea',
  },
  readingBetweenLines: {
    'en-US': '...and reading between the lines',
    'en-GB': '...and reading between the lines',
    'en-AU': '...and reading between the lines',
    'en-IN': '...and reading between the lines',
    'es-ES': '...y leyendo entre líneas',
    'es-US': '...y leyendo entre líneas',
  },
  watchingWaterBoil: {
    'en-US': '...and watching water boil',
    'en-GB': '...and watching the kettle boil',
    'en-AU': '...and watching the kettle boil',
    'en-IN': '...and watching water boil',
    'es-ES': '...y viendo hervir el agua',
    'es-US': '...y viendo hervir el agua',
  },
  connectingDots: {
    'en-US': '...and connecting the dots',
    'en-GB': '...and connecting the dots',
    'en-AU': '...and connecting the dots',
    'en-IN': '...and connecting the dots',
    'es-ES': '...y conectando los puntos',
    'es-US': '...y conectando los puntos',
  },
  pretendingToWork: {
    'en-US': '...and pretending to work',
    'en-GB': '...and pretending to work',
    'en-AU': '...and pretending to work',
    'en-IN': '...and pretending to work',
    'es-ES': '...y fingiendo trabajar',
    'es-US': '...y haciendo como que trabaja',
  },
  overthinkingEverything: {
    'en-US': '...and overthinking everything',
    'en-GB': '...and overthinking everything',
    'en-AU': '...and overthinking everything',
    'en-IN': '...and overthinking everything',
    'es-ES': '...y dándole vueltas a todo',
    'es-US': '...y pensando demasiado',
  },
  speedrunningLife: {
    'en-US': '...and speedrunning life',
    'en-GB': '...and speedrunning life',
    'en-AU': '...and speedrunning life',
    'en-IN': '...and speedrunning life',
    'es-ES': '...y haciendo speedrun de la vida',
    'es-US': '...y speedruneando la vida',
  },
  arguingWithMyself: {
    'en-US': '...and arguing with myself',
    'en-GB': '...and arguing with myself',
    'en-AU': '...and arguing with myself',
    'en-IN': '...and arguing with myself',
    'es-ES': '...y discutiendo conmigo mismo',
    'es-US': '...y peleando conmigo mismo',
  },
  countingBackwards: {
    'en-US': '...and counting backwards',
    'en-GB': '...and counting backwards',
    'en-AU': '...and counting backwards',
    'en-IN': '...and counting backwards',
    'es-ES': '...y contando hacia atrás',
    'es-US': '...y contando al revés',
  },
  readingEveryBook: {
    'en-US': '...and reading every book',
    'en-GB': '...and reading every book',
    'en-AU': '...and reading every book',
    'en-IN': '...and reading every book',
    'es-ES': '...y leyendo todos los libros',
    'es-US': '...y leyendo todos los libros',
  },
  contemplatingLife: {
    'en-US': '...and contemplating life',
    'en-GB': '...and contemplating life',
    'en-AU': '...and contemplating life',
    'en-IN': '...and contemplating life',
    'es-ES': '...y contemplando la vida',
    'es-US': '...y reflexionando sobre la vida',
  },
  staringOutTheWindow: {
    'en-US': '...and staring out the window',
    'en-GB': '...and staring out the window',
    'en-AU': '...and staring out the window',
    'en-IN': '...and staring out the window',
    'es-ES': '...y mirando por la ventana',
    'es-US': '...y mirando por la ventana',
  },
  callingMom: {
    'en-US': '...and calling my mom',
    'en-GB': '...and calling my mum',
    'en-AU': '...and calling my mum',
    'en-IN': '...and calling mummy',
    'es-ES': '...y llamando a mi madre',
    'es-US': '...y llamando a mi mamá',
  },
};
